export const environment = {
  production: true,
  apiUrl: '/api',
  docUrl: '/docs',
  keycloak: {
    url: '/auth',
    realm: 'apps',
    clientId: 'appsui'
  },
   downloadsUrl: 'https://test.downloads.braxos.com',
   zabbixUrl: 'https://zabbix.ops.braxos.net'
};
